import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ErrorIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0628 0C37.3499 0 48.1255 10.7756 48.1255 24.0628C48.1255 37.3499 37.3499 48.1255 24.0628 48.1255C10.7756 48.1255 0 37.3499 0 24.0628C0 10.7756 10.7756 0 24.0628 0ZM21.4848 26.1334V13.7486C21.4848 12.3288 22.643 11.1707 24.0628 11.1707C25.4826 11.1707 26.6407 12.3395 26.6407 13.7486V26.1334C26.6407 27.5424 25.4825 28.7113 24.0628 28.7113C22.643 28.7113 21.4848 27.5532 21.4848 26.1334ZM24.0516 31.4762C25.6651 31.4762 26.9736 32.7848 26.9736 34.398C26.9736 36.0115 25.6651 37.3201 24.0516 37.3201C22.4384 37.3201 21.1298 36.0115 21.1298 34.398C21.1298 32.7848 22.4384 31.4762 24.0516 31.4762Z"
        fill="#EF233C"
      />
    </svg>
  )
})

ErrorIcon.displayName = 'ErrorIcon'
